<div class="row">
  <div class="col-12">
    <div class="btn-filter" *ngIf="isOpen" (click)="isOpen = false">
      <span nz-icon nzType="arrow-up" nzTheme="outline" class="mr-2"></span>
      Ẩn bộ lọc
    </div>
    <div class="btn-filter" *ngIf="!isOpen" (click)="isOpen = true">
      <span nz-icon nzType="arrow-down" nzTheme="outline" class="mr-2"></span>
      Hiện bộ lọc
    </div>
  </div>
  <div class="col-12 container-params-filter" *ngIf="isOpen">
    <ng-content></ng-content>  
    <div class="mt-3 col-4 ml-auto">
      <div class="d-flex justify-content-end align-items-center ">
        <span style="margin-right: 40px;"  *ngIf="!isHideTotal">Tổng {{total | number}} kết quả
        </span>
        <button nz-button nzType="primary" *ngIf="isSearch" (click)="search()">Tìm kiếm</button>
      </div>
    </div>
  </div>
</div>